import { Row, Col, Form } from "react-bootstrap"
import { useState } from "react"
// import { useParams } from "react-router-dom"
import { useCallback, useEffect } from "react"
import { useSelector } from 'react-redux';
import AddEvent from "./events/AddEvent";
import EventCard from './events/EventCard';


export default function EventsCard({ onCountChange }) {

  const url = process.env.REACT_APP_URL;
  // const meetingId = useParams().meetingId;

  const [events, setEvents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const { user: authUser } = useSelector(x => x.auth);

  const getEvents = useCallback(async () => {
    try {
      const response = await fetch(`${url}/agendaEvents`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      const data = await response.json();
      setEvents(data);
    } catch (e) {
      console.log(`Events component - Get Events error: ${e}`);
    }
  }, [url]);

  useEffect(() => {
    getEvents();
  }, [getEvents]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredEvents = events.filter(event =>
    String(event?.name || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedEvents = [...filteredEvents].sort((a, b) =>
    String(a?.name || '').localeCompare(String(b?.name || ''))
  );

  useEffect(() => {
    if (typeof onCountChange === 'function') {
      onCountChange(sortedEvents.length);
    }
  }, [onCountChange, sortedEvents.length]);

  return (
    <div className='events-roles-admin-panel events-admin-panel'>
      <div className='events-admin-top'>
        <h5 className='mb-0'>Meeting Events</h5>
      </div>

      <div className='events-roles-admin-controls'>
        <Row className='header mb-2'>
          {(authUser && authUser.user.acl === 'Officer') &&
            <Col xs={12} lg={12} key={'newEvent'}>
              <AddEvent getEvents={getEvents} />
            </Col>
          }
        </Row>
        <Row className='mb-3'>
          <Col xs={12} lg={12}>
            <div className='assignments-search-wrap'>
              <Form.Control
                type="text"
                placeholder="Search for an event..."
                value={searchTerm}
                onChange={handleSearchChange}
                data-bs-theme={'dark'}
                className='assignments-search-input'
              />
              {searchTerm && (
                <button
                  type='button'
                  className='assignments-search-clear'
                  onClick={() => setSearchTerm('')}
                  aria-label='Clear search'
                >
                  <i className='bi bi-x' />
                </button>
              )}
            </div>
          </Col>
        </Row>
      </div>
      <div className='events-roles-admin-list'>
        <Row className='events-list m-0'>
          {sortedEvents.map(event => (
            <Col xs={12} lg={12} key={event._id} className='mb-2 px-0'>
              <EventCard event={event} getEvents={getEvents} />
            </Col>
          ))}
        </Row>
      </div>
    </div>
  )
}